import { render } from "./Value.vue?vue&type=template&id=e9f627be"
import script from "./Value.vue?vue&type=script&lang=js"
export * from "./Value.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1097443038/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__